import { fonts } from '../design-tokens/fonts';
export default {
  /**
   * Legacy references
   */
  formular: fonts.secondary,
  spoof: fonts.primary,
  mPlus1: fonts.japanese,
  vazirmatn: fonts.arabic
};